<template>
  <v-card class="pa-4" outlined elevation="8">
    <v-list-item class="px-6" height="88">
      <!-- <template v-slot:prepend>
        <v-avatar color="surface-light" size="32">🎯</v-avatar>
      </template> -->

      <template v-slot:title>
        <span class="text-h5">
          Ventes en points {{ selectedYear.text }} (prix tarif)
        </span>
      </template>

      <template v-slot:append>
        <v-btn
          class="text-white"
          color="#ffb500"
          :icon="
            type == 'table'
              ? mdiFileTableBoxMultipleOutline
              : mdiChartBoxMultipleOutline
          "
          slim
          @click="changeView"
        ></v-btn>
      </template>
    </v-list-item>
    <!-- <v-card-title class="text-h5">
      Ventes en points {{ selectedYear.text }} (prix tarif)
    </v-card-title> -->
    <v-card-text v-if="type == 'chart'">
      <!-- <v-select
        :items="years"
        density="compact"
        label="Année"
        item-value="value"
        item-title="text"
        return-object
        single-line
        @update:modelValue="getStatisticsByYear"
        v-model="selectedYear"
      ></v-select> -->

      <v-row justify="center" align="center" class="mb-4">
        <v-col cols="12" md="12" sm="12">
          <div id="chart">
            <apexchart
              type="bar"
              height="350"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text v-else>
      <!-- <v-select
        :items="years"
        density="compact"
        label="Année"
        item-value="value"
        item-title="text"
        return-object
        single-line
        @update:modelValue="getStatisticsByYear"
        v-model="selectedYear"
      ></v-select> -->
      <v-row>
        <v-col cols="11">
          <v-text-field
            v-model="search"
            label="Rechercher"
            :prepend-inner-icon="mdiMagnify"
            variant="outlined"
            hide-details
            single-line
          ></v-text-field>
        </v-col>
        <v-col cols="1">
          <v-btn
            :icon="mdiFileDownloadOutline"
            rounded="lg"
            border
            @click="exportExcelFranchise"
          ></v-btn>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="statistics"
        items-per-page="-1"
        hide-default-footer
        :search="search"
        fixed-header
        class="table-with-horizontal-scroll"
      >
        <template v-slot:item.cA_N="{ item }">
          {{ Math.round(item.cA_N).toLocaleString("fr-FR") }} €
        </template>

        <template v-slot:item.cA_N_Minus_1="{ item }">
          {{ Math.round(item.cA_N_Minus_1).toLocaleString("fr-FR") }} €
        </template>

        <template v-slot:item.cA_N_Filtered="{ item }">
          {{ Math.round(item.cA_N_Filtered).toLocaleString("fr-FR") }} €
        </template>

        <template v-slot:item.cA_N_Filtered_SEA="{ item }">
          {{ Math.round(item.cA_N_Filtered_SEA).toLocaleString("fr-FR") }} €
        </template>

        <template v-slot:item.sea="{ item }">
          {{ Math.round(item.sea).toLocaleString("fr-FR") }}
        </template>

        <template v-slot:item.totalGeneratedPoints="{ item }">
          {{ Math.round(item.totalGeneratedPoints).toLocaleString("fr-FR") }}
        </template>

        <template v-slot:item.projectedTotalPoints="{ item }">
          {{ Math.round(item.projectedTotalPoints).toLocaleString("fr-FR") }}
        </template>

        <template v-slot:item.totalPoints="{ item }">
          {{ Math.round(item.totalPoints).toLocaleString("fr-FR") }}
        </template>

        <template v-slot:item.totalProducts="{ item }">
          {{ Math.round(item.totalProducts).toLocaleString("fr-FR") }}
        </template>

        <template v-slot:item.theoreticalAnnualContributions="{ item }">
          {{
            Math.round(item.theoreticalAnnualContributions).toLocaleString(
              "fr-FR",
            )
          }}
        </template>

        <template v-slot:item.projectedImpactVsCaN="{ item }">
          {{ Number(item.projectedImpactVsCaN).toFixed(2) }} %
        </template>

        <template v-slot:item.franchise.name="{ item }">
          <v-chip color="#ffb500" text-color="white" small>
            {{ item.franchise.name }}
          </v-chip>
        </template>

        <template v-slot:item.growthEstimate="{ item }">
          <span v-if="item.cA_N_Minus_1 === 0"> N/A </span>
          <span
            v-else-if="
              (
                ((item.cA_N - item.cA_N_Minus_1_Date) /
                  item.cA_N_Minus_1_Date) *
                100
              ).toFixed(2) < 0
            "
            class="text-red font-weight-bold"
          >
            {{
              (
                ((item.cA_N - item.cA_N_Minus_1_Date) /
                  item.cA_N_Minus_1_Date) *
                100
              ).toFixed(2)
            }}
            %
          </span>
          <span v-else class="text-green font-weight-bold">
            {{
              (
                ((item.cA_N - item.cA_N_Minus_1_Date) /
                  item.cA_N_Minus_1_Date) *
                100
              ).toFixed(2)
            }}
            %
          </span>
        </template>

        <template v-slot:tfoot>
          <tr class="bg-grey-lighten-4">
            <td class="font-weight-bold">Total :</td>
            <td class="text-center">{{ getTotalValueFormatted("cA_N") }} €</td>
            <td class="text-center">
              {{ getTotalValueFormatted("cA_N_Minus_1") }} €
            </td>
            <td class="text-center">
              {{ getTotalValueFormatted("cA_N_Filtered") }} €
            </td>
            <td class="text-center">
              {{ getTotalValueFormatted("cA_N_Filtered_SEA") }} €
            </td>
            <td class="text-center">{{ getTotalValueFormatted("sea") }} €</td>
            <td class="text-center">
              {{ getTotalValueFormatted("totalGeneratedPoints") }}
            </td>
            <td class="text-center">{{ getTotalValue("totalOrders") }}</td>
            <td class="text-center">
              {{ getTotalValueFormatted("totalPoints") }}
            </td>
            <td class="text-center">
              {{ getTotalValueFormatted("projectedTotalPoints") }}
            </td>
            <td class="text-center">
              {{ getTotalValueFormatted("totalProducts") }}
            </td>
            <td class="text-center">
              {{ getTotalValueFormatted("theoreticalAnnualContributions") }}
            </td>
            <td class="text-center">
              {{
                (
                  (((getTotalValue("theoreticalAnnualContributions") /
                    todayMonth) *
                    12) /
                    ((getTotalValue("cA_N") / todayMonth) * 12)) *
                  100
                ).toFixed(2)
              }}
              %
            </td>
            <td
              class="text-center"
              :class="{
                'text-red font-weight-bold':
                  ((getTotalValue('cA_N') - getTotalValue('cA_N_Minus_1')) /
                    getTotalValue('cA_N_Minus_1')) *
                    100 <
                  0,
                'text-green font-weight-bold':
                  ((getTotalValue('cA_N') - getTotalValue('cA_N_Minus_1')) /
                    getTotalValue('cA_N_Minus_1')) *
                    100 >
                  0,
              }"
            >
              {{
                (
                  ((getTotalValue("cA_N") - getTotalValue("cA_N_Minus_1")) /
                    getTotalValue("cA_N_Minus_1")) *
                  100
                ).toFixed(2)
              }}
              %
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiChartBoxMultipleOutline,
  mdiFileTableBoxMultipleOutline,
  mdiMagnify,
  mdiFileDownloadOutline,
} from "@mdi/js";
import { mapState } from "vuex";
import contractYear from "@/mixins/contractYear";

export default {
  name: "FranchiseKpi",
  mixins: [contractYear],
  components: {},
  data() {
    return {
      search: "",
      mdiChartBoxMultipleOutline,
      mdiFileTableBoxMultipleOutline,
      mdiMagnify,
      mdiFileDownloadOutline,
      type: "table",
      todayMonth: new Date().getMonth() + 1,
    };
  },
  computed: {
    ...mapState({
      statistics: (state) => state.kpi.statisticsItems,
    }),
    /**
     * Génère la liste des années disponibles de 2024 à l'année contractuelle courante
     * @returns {Array<Object>} Liste des années avec text et value
     */
    years() {
      const startYear = 2024;
      const currentYear = this.selectedYear.value;
      const years = [];
      for (let i = startYear; i <= currentYear; i++) {
        years.push({ text: String(i), value: i });
      }
      return years;
    },
    headers() {
      return [
        { title: "Sous franchise", key: "franchise.name" },
        {
          title: `CA ${this.selectedYear.value} YTD`,
          key: "cA_N",
          align: "center",
        },
        {
          title: `CA ${this.selectedYear.value - 1}`,
          key: "cA_N_Minus_1",
          align: "center",
        },
        {
          title: `CA ${this.selectedYear.value} (hors leaser) YTD`,
          key: "cA_N_Filtered",
          align: "center",
        },
        {
          title: `CA ${this.selectedYear.value} (hors leaser) + SEA YTD`,
          key: "cA_N_Filtered_SEA",
          align: "center",
        },
        {
          title: `SEA ${this.selectedYear.value} YTD`,
          key: "sea",
          align: "center",
        },
        {
          title: "Total des points générés YTD",
          key: "totalGeneratedPoints",
          align: "center",
        },
        {
          title: "Total des commandes en point YTD",
          key: "totalOrders",
          align: "center",
        },
        {
          title: "Total des points dépensés YTD",
          key: "totalPoints",
          align: "center",
        },
        {
          title: "Total des points dépensés prévisionnel fin d'année",
          key: "projectedTotalPoints",
          align: "center",
        },
        {
          title: "Total des produits vendus (en points) YTD",
          key: "totalProducts",
          align: "center",
        },
        {
          title: "Cotisations théoriques annuelles projetées",
          key: "theoreticalAnnualContributions",
          align: "center",
        },
        {
          title: "Impact prévisionnel à la fin d'année VS CA N projeté",
          key: "projectedImpactVsCaN",
          align: "center",
        },
        {
          title: "Croissance estimée en %",
          key: "growthEstimate",
          align: "center",
        },
      ];
    },
  },
  methods: {
    exportExcelFranchise() {
      this.$store.commit("setOverlay", true);
      this.$store
        .dispatch("kpi/exportExcelFranchise", {
          year: this.selectedYear.value,
          month: this.selectedMonth,
        })
        .then((response) => {
          this.$store.commit("setOverlay", false);
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // Create a link element
          const link = document.createElement("a");
          // Set the download attribute with the desired file name
          link.download = "DivisionsKPI.xlsx";

          // Create a URL for the Blob and set it as the link's href
          link.href = window.URL.createObjectURL(blob);

          // Append the link to the document
          document.body.appendChild(link);

          // Trigger a click on the link to start the download
          link.click();

          // Remove the link from the document
          document.body.removeChild(link);
        })
        .catch((error) => {
          if (error.status == 400) {
            this.$store.commit("setOverlay", false);
            this.$store.dispatch("showSnackbar", {
              message: "Action non autorisée.",
              color: "error",
            });
          } else {
            this.$store.commit("setOverlay", false);
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.export-excel"),
              color: "error",
            });
          }
        });
    },
    changeView() {
      this.type = this.type === "table" ? "chart" : "table";
    },
    getStatisticsByYear(value) {
      this.$store.commit("setOverlay", true);
      this.$store
        .dispatch("kpi/fetchFranchiseStatistics", value.value)
        .then(() => {
          this.$store.commit("setOverlay", false);
        })
        .catch(() => {
          this.$store.commit("setOverlay", false);
        });
    },
    /**
     * Calcule la somme totale d'une propriété spécifique sur tous les éléments de statistiques
     * @param {string} property - La propriété à totaliser
     * @returns {number} - Le total calculé
     */
    getTotalValue(property) {
      // Gestion des propriétés imbriquées comme 'franchise.name'
      if (property.includes(".")) return "-";

      return this.statistics.reduce((acc, item) => {
        return acc + Math.round(item[property] || 0);
      }, 0);
    },
    /**
     * Retourne la valeur totale formatée pour l'affichage
     * @param {string} property - La propriété à totaliser
     * @returns {string} - Le total formaté en français
     */
    getTotalValueFormatted(property) {
      const total = this.getTotalValue(property);
      return total.toLocaleString("fr-FR");
    },
  },
  props: {
    chartOptions: {
      type: Object,
      required: true,
    },
    series: {
      type: Array,
      required: true,
    },
    selectedYear: {
      type: Object,
      required: true,
      validator: (value) => value.text && value.value !== undefined,
    },
    selectedMonth: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style scoped>
.table-with-horizontal-scroll {
  overflow-x: auto;
  white-space: nowrap;
}

/* Pour que les cellules du tableau aient une largeur minimale */
.table-with-horizontal-scroll :deep(th),
.table-with-horizontal-scroll :deep(td) {
  min-width: 130px;
}

/* Première colonne fixe lors du scroll horizontal */
.table-with-horizontal-scroll :deep(th:first-child),
.table-with-horizontal-scroll :deep(td:first-child) {
  position: sticky !important;
  left: 0;
  z-index: 2;
  background-color: white;
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
}

/* Style pour l'en-tête de la première colonne */
.table-with-horizontal-scroll :deep(thead th:first-child) {
  z-index: 3 !important;
  background-color: rgb(var(--v-theme-surface));
}

/* Style pour le footer */
.table-with-horizontal-scroll :deep(tfoot td:first-child) {
  background-color: rgb(245, 245, 245);
  z-index: 2;
}
</style>
